import React from 'react';
import { ProgramRequestsTable } from './admin/program-requests-table';
import { ProgramRequestsInstitutionTable } from "./institution/program-requests-table-institution";

export const ReviewTab = ({ data }) => {
    return (
        <div
            className="tab-pane fade show active"
            id="review"
            role="tabpanel"
            aria-labelledby="review-tab"
        >
            <div className="card">
                <div className="table-responsive">
                    {data && data[0] && data[0].isAdmin && <ProgramRequestsTable
                      tableData={data}
                    />}
                    {data && data[0] && !data[0].isAdmin && <ProgramRequestsInstitutionTable
                      tableData={data}
                    />}
                </div>
            </div>
        </div>
    );
};
